module.exports = __webpack_public_path__ + "img/InsanityMax30.d2a11e74.jpeg";